import * as React from 'react';

import { ToggleButton } from '@/components/ui/toggle-button/toggle-button';

import type { BhanzuBuddyChatHeaderProps } from './bhanzu-buddy-chat-types';

/**
 * Chat Header Component with title and toggle
 */
export const BhanzuBuddyChatHeader: React.FC<BhanzuBuddyChatHeaderProps> = ({
  onToggleMode,
  currentMode = 'explain',
}) => {
  const toggleOptions = [
    { value: 'explain', label: 'Explain' },
    { value: 'guide', label: 'Guide' },
  ];

  const handleToggleChange = React.useCallback(
    (value: string) => {
      if (value === 'explain' || value === 'guide') {
        onToggleMode?.(value);
      }
    },
    [onToggleMode]
  );

  return (
    <div className="flex items-center justify-between p-4 sm:p-6 border-b border-gray-700/50">
      {/* Title */}
      <h1 className="text-white text-xl sm:text-2xl font-semibold">
        Bhanzubuddy
      </h1>

      {/* Toggle Button */}
      <ToggleButton
        options={toggleOptions}
        value={currentMode}
        onChange={handleToggleChange}
        size="md"
      />
    </div>
  );
};
